import script from "./dialog-faq.vue?vue&type=script&lang=ts&setup=true"
export * from "./dialog-faq.vue?vue&type=script&lang=ts&setup=true"

import "./dialog-faq.vue?vue&type=style&index=0&id=8e701abe&lang=scss"

const __exports__ = script;

export default __exports__